import {UsuarioInfoNavLink, UsuarioInfoTextField} from '@components/contas/UsuarioInformacao.tsx';
import {RecursoInformacaoNavLink, RecursoInfoTextField,} from '@components/recurso/RecursoInformacao.tsx';
import {useGeneral} from '@contexts/GeneralContext.tsx';
import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {DefaultEventProps, DefaultInformationProps, DefaultNavLinkProps} from '@models/DefaultProps.ts';
import {IRecursoTransferenciaSolicitacao} from '@models/recurso/IRecursoTransferencia.ts';
import {Grid, TableCell, TableRow, TextField, Typography} from '@mui/material';
import {DateTimeField} from '@mui/x-date-pickers';
import {NavigationLink, NavigationLinkProps} from '@shared/custom/NavigationLink.tsx';
import {MoneyInputEntry} from '@shared/specialComponents/InputEntry.tsx';
import dayjs from 'dayjs';
import React from 'react';

export interface RecursoTransferenciaInformacaoProps extends DefaultInformationProps<IRecursoTransferenciaSolicitacao> {
    variant: "grid" | "list" | "navigationLink" | "row";
}

export const RecursoTransferenciaInformacao: React.FC<RecursoTransferenciaInformacaoProps> = (props) => {
    const {variant} = props;

    if (variant == 'list') return <RecursoTransferenciaInfoList {...props} />;

    return (<></>);
};

export const RecursoTransferenciaInfoRow: React.FC<Omit<RecursoTransferenciaInformacaoProps, 'variant' | 'overrides'>> = (props) => {
    const {value, EndComponent} = props;

    return (
        <TableRow>
            <TableCell>
                <RecursoTransferenciaInfoNavLink {...props} slotProps={{chip: {tableMode: true}}}/>
            </TableCell>
            <TableCell>
                {value.recurso &&
                    <RecursoInformacaoNavLink value={value.recurso} slotProps={{chip: {tableMode: true}}}/>}
            </TableCell>
            <TableCell>
                {value.solicitante &&
                    <UsuarioInfoNavLink value={value.solicitante} slotProps={{chip: {tableMode: true}}}/>}
            </TableCell>
            <TableCell>
                {EndComponent && <EndComponent {...value}/>}
            </TableCell>
        </TableRow>
    );
};

export const RecursoTransferenciaInfoList: React.FC<Omit<RecursoTransferenciaInformacaoProps, 'variant' | 'overrides'>> = (props) => {
    const {value, EndComponent} = props;

    return (
        <Grid container alignItems={'center'} justifyContent={'space-between'}>
            <Grid size={'grow'}>
                <Grid container spacing={1}>
                    <Grid>
                        <RecursoTransferenciaInfoNavLink value={value}/>
                    </Grid>
                    {value.recurso && <Grid>
                        <RecursoInformacaoNavLink value={value.recurso}/>
                    </Grid>}
                    {value.solicitante && <Grid>
                        <UsuarioInfoNavLink value={value.solicitante}/>
                    </Grid>}
                </Grid>
            </Grid>
            {EndComponent && <Grid>
                <EndComponent {...value}/>

            </Grid>}
        </Grid>
    );
};

export const RecursoTransferenciaInfoNavLink: React.FC<Omit<RecursoTransferenciaInformacaoProps, 'variant' | 'overrides' | 'EndComponent'> &
    Omit<DefaultNavLinkProps<IRecursoTransferenciaSolicitacao>, 'pathName' | 'searchData'>> = (props) => {

    const navProps: NavigationLinkProps = {
        ...props,
        displayMode: props.displayMode ?? 'id',
        slotProps: {
            chip: {
                tableMode: props.slotProps?.chip?.tableMode,
                sx: props.slotProps?.chip?.sx,
            },
        },
        pathName: _Sitemap.recurso.children.transferencias.children.detalhes.fullUrl,
        searchData: {transferenciaId: props.value.id},
    };

    return (
        <NavigationLink {...navProps} {...navProps.slotProps?.chip} />);
};

export const RecursoTransferenciaInfoGrid: React.FC<Omit<RecursoTransferenciaInformacaoProps, 'variant' | 'overrides'> & Pick<DefaultEventProps, 'onUpdate'>> = (props) => {
    const {screenSizeLevel} = useGeneral();

    const {value} = props;
    return (<Grid spacing={1} container alignItems={'center'}>

        <Grid size={12}>
            <Grid container spacing={1.5} alignItems={'center'} justifyContent={'space-between'}>
                <Typography>
                    Solicitação de transferência
                </Typography>
                <RecursoTransferenciaInfoNavLink {...props}/>
            </Grid>
        </Grid>

        <Grid size={screenSizeLevel > 6 ? 12 : 6}>
            <MoneyInputEntry value={value.valorSolicitado} label={'Valor solicitado'}/>
        </Grid>
        <Grid size={screenSizeLevel > 6 ? 12 : 6}>{value.recurso &&
            <RecursoInfoTextField label={'Recurso solicitado'} value={value.recurso}/>}
        </Grid>
        <Grid size={screenSizeLevel > 6 ? 12 : 6}>
            <DateTimeField value={dayjs(value.dataSolicitacao)} fullWidth disabled label={'Data da solicitação'}/>
        </Grid>
        <Grid size={screenSizeLevel > 6 ? 12 : 6}>{value.solicitante &&
            <UsuarioInfoTextField label={'Usuario solicitante'} value={value.solicitante}/>}
        </Grid>
        <Grid size={screenSizeLevel > 6 ? 12 : 6}>
            <TextField disabled value={value.statusAprovacao} fullWidth label={'Status'}/>
        </Grid>
        <Grid size={screenSizeLevel > 6 ? 12 : 6}>
            <TextField disabled value={value.nivelAprovacao} fullWidth label={'Função do solicitante'}/>
        </Grid>

    </Grid>);
};